import React from "react";
import { AppProvider } from "@context/AppContext";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import GTM from "@utils/GTM";

import "./src/styles/global.css";
import "./src/styles/cookies.css";

export const onRouteUpdate = () => {
  GTM.reset();
};

export const wrapRootElement = ({ element }) => (
  <GoogleReCaptchaProvider reCaptchaKey={process.env.GATSBY_GOOGLE_RECAPTCHA_SITE_KEY}>
    <AppProvider>{element}</AppProvider>
  </GoogleReCaptchaProvider>
);
